import React from "react";

export const CALC_PRODUCTS = [
  "Video Brochure",
  "Video Boxes",
  "Premium Book",
  "Custom Box",
];

export const ProductTypeSelector = ({ value, onChange, products = CALC_PRODUCTS }) => (
  <div className="mt-6">
    <label className="text-sm font-semibold text-black/70">Επιλέξτε Είδος</label>
    <div className="mt-3 flex flex-wrap gap-2">
      {products.map((p) => (
        <button
          key={p}
          type="button"
          data-testid={`calc-product-${p}`}
          onClick={() => onChange(p)}
          className={`rounded-full border px-4 py-2 text-sm font-medium transition-all ${
            value === p
              ? "border-brand-500 bg-brand-500 text-white"
              : "border-black/10 bg-white text-black/70 hover:border-brand-300"
          }`}
        >
          {p}
        </button>
      ))}
    </div>
  </div>
);
